<template>
  <interface-text-popover
    v-if="payload"
    :content="tooltip"
    trigger="hover"
    placement="top"
  >
    <span v-html="text"></span>
  </interface-text-popover>
</template>

<script>
import InterfaceTextPopover from './InterfaceTextPopover';

export default {
  components: { InterfaceTextPopover },
  props: {
    payload: {
      type: String,
      default: null
    }
  },
  computed: {
    params() {
      if (!this.payload) {
        return {};
      }
      return JSON.parse(atob(this.payload));
    },
    tooltip() {
      return this.url;
    },
    url() {
      // Inject "redirect back" url
      let url = this.params.tooltip;

      if (url && !url.includes('redirect=') && url.includes('selected=')) {
        let chunks = url.split('?selected=');

        url =
          chunks[0] +
          '?redirect=' +
          btoa(document.location) +
          '&selected=' +
          chunks[1];
      }

      return url;
    },
    text() {
      return this.params.text;
    }
  },
  mounted() {
    // Change class name to avoid returning this element for later selector in jQuery
    this.$el.className = 'editable-interface-text';
  }
};
</script>

<style>
.edit-interface-text:hover,
.editable-interface-text:hover {
  text-decoration: underline dotted;
  cursor: default;
}
</style>
